// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"c86cc85d","88":"8f795c0b","262":"5b994eab","343":"7f889d0a","453":"bd6ba36f"}[chunkId] + ".chunk.js";
};